import styled from 'styled-components'
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px;
  
  @media screen and (max-width: 940px) {
    padding: 24px 4px;
    gap: 16px;
  }
`
export const TotalAccountRewards = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${p => p.theme.color.background.secondary};
  border: 1px solid ${p => p.theme.color.background.border.main};
  border-radius: 12px;
  padding: 32px;
  width: 100%;
  box-sizing: border-box;
  
  @media screen and (max-width: 860px) {
    padding: 20px 12px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
  }
`
export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`
export const TablesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;

  @media screen and (max-width: 940px) {
    gap: 16px;
  }
  
  @media screen and (max-width: 860px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px;
  }
`